export interface UtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}

export interface QuizContext extends UtmParams {
  ref?: string; // ?ref={profile} pour proof social
  referrer?: string;
  userAgent?: string;
}

const UTM_KEYS: (keyof UtmParams)[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

const STORAGE_KEY = "quiz_utm_v1";

export function readContextFromUrl(): QuizContext {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const ctx: QuizContext = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) ctx[k] = v;
  });
  const ref = params.get("ref");
  if (ref) ctx.ref = ref.toLowerCase();
  ctx.referrer = document.referrer || undefined;
  ctx.userAgent = navigator.userAgent;
  return ctx;
}

/** Lit l'UTM stocké (si l'utilisateur revient plus tard avec une URL nue, on garde la source d'origine). */
export function getStoredContext(): QuizContext {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as QuizContext;
  } catch {
    /* ignore */
  }
  return {};
}

export function persistContext(ctx: QuizContext) {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ctx));
  } catch {
    /* ignore */
  }
}

/** Hydrate l'objet de contexte au démarrage : URL > storage. */
export function hydrateContext(): QuizContext {
  const fromUrl = readContextFromUrl();
  const stored = getStoredContext();
  const merged = { ...stored, ...fromUrl };
  persistContext(merged);
  return merged;
}

export function appendUtm(url: string, ctx: UtmParams): string {
  const u = new URL(url);
  Object.entries(ctx).forEach(([k, v]) => {
    if (v) u.searchParams.set(k, v);
  });
  return u.toString();
}
